import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import PropTypes from 'prop-types';

interface BarChartProps {
  data: any,
  isInsurer?:boolean
}
const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August',
  'September',
  'October',
  'November',
  'December']

const demoData = {
  labels:  ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec'],
  datasets: [
    {
      label: 'Dataset 1',
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      borderColor: '#fbc02d',
      backgroundColor:'#00ADC6',
      tension: 0.2,
      fill: true,
      pointColor: '#FBC02D'
    }
  ]
};



  const options = {
    maintainAspectRatio: false,
  aspectRatio:1.5,
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: true,
        },
      },
    },
    plugins: {
      legend: {
        display: false, // Hide the chart title
      },
    },
  };

  // const ctx = document.getElementById('barChart')?.getContext('2d');

const BarChart: React.FC<BarChartProps> = ({ data, isInsurer }) => {
  const [chartData, setChartData] = useState(demoData);
 const dta = [data]
  //const metricsDataLabels = Object.keys(data)?.map((item) => `Wk ${item}`);
  

  useEffect(() => {
    const metricsDataList = Object.values(dta);
    const metricsChartData = {
      labels:  ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug',
        'Sept',
        'Oct',
        'Nov',
        'Dec'],
      datasets: [
        {
          label: 'Value',
          data: metricsDataList,
          borderColor: '#fbc02d',
          backgroundColor:  '#00ADC6',
          tension: 0.2,
          fill: true,
          pointColor: '#FBC02D',
          
        }
      ]
    };

    setChartData(isInsurer ? data : metricsChartData);
  }, [data]);

 

  return (
    <div className="bar-chart">
      <Bar data={chartData} options={options} id={'barChart'} className='h-[400px] w-[1000px]  !bg-[#FFFCF5]'/>
    </div>
  );
};
// BarChart.propTypes = {
//   data: PropTypes.object,
//   height: PropTypes.string,
//   width: PropTypes.string
// };


export default BarChart;
